import {
  useShopifyCurrencyConverter,
  DEFAULT_CURRENCY_ANALYTIC,
  useCurrencyStore,
} from '~/modules/analytics';
import { getCurrencySymbol, getPriceByCurrency, trimDecimalZeros } from '~/utils';
import { useShopifyStore } from '../stores/shopify';
import { useMemo } from 'react';

export const useConvertMoneyByCurrency = () => {
  const currency = useShopifyStore((state) => state.shopShopify?.currency ?? '');
  const currencyMode = useCurrencyStore((state) => state.currencyMode);
  const locale = useShopifyStore((state) => state.shopShopify?.primary_locale ?? '') || 'en-US';
  const currencies = useShopifyStore((state) => state.currencies);
  const currencySymbol = useMemo(() => getCurrencySymbol(currency, locale), [currency, locale]);

  const { convertAmount } = useShopifyCurrencyConverter();

  const getTextPrice: IGetTextPrice = (price, _hasCurrency, options) => {
    if (typeof price === 'string') return price;
    if (typeof price !== 'number') return '0';

    if (!currencyMode) return price.toString();

    const finalPrice = convertAmount(price, DEFAULT_CURRENCY_ANALYTIC, currencyMode);
    const newPrice = getPriceByCurrency(finalPrice, currencyMode, {
      locale,
      compact: options?.compact,
    });

    return trimDecimalZeros(newPrice);
  };

  return {
    getTextPrice,
    locale,
    currencies,
    currency,
    currencySymbol,
  };
};

export type IConvertMoneyByCurrency = ReturnType<typeof useConvertMoneyByCurrency>;
export type IGetTextPrice = (
  price?: number | string | null,
  hasCurrency?: boolean,
  options?: { compact?: boolean },
) => string;
